import { IDealRoomSectionContent } from '@app/interfaces/deal-room';
import { DealRoomDisabledSection, DealRoomSection } from './enums/deal-room';

export const dealRoomBaseSections: IDealRoomSectionContent[] = [
  {
    key: DealRoomSection.OPENING,
    labelKey: 'dealRooms.sections.opening',
    display: false,
    highlighted: false,
    default: false,
    label: null,
    isEditing: false,
    isAdditional: false,
    isExternal: false,
    file: null,
  },
  {
    key: DealRoomSection.INSURANCE_COVERAGE_SHARED_BUILDING,
    labelKey: 'dealRooms.sections.insuranceCoverageSharedBuilding',
    display: false,
    highlighted: false,
    default: false,
    label: null,
    isEditing: false,
    isAdditional: false,
    isExternal: false,
    file: null,
    subMenu: [
      {
        key: DealRoomSection.THIRD_PARTY_INSURANCE,
        labelKey: 'dealRooms.sections.thirdPartyInsurance',
        display: false,
        highlighted: false,
        default: false,
        label: null,
        isEditing: false,
        isAdditional: false,
        isExternal: false,
        file: null,
      },
      {
        key: DealRoomSection.PERSONAL_CLAIMS_FOR_COMMITTEE_MEMBERS,
        labelKey: 'dealRooms.sections.personalClaimsForCommitteeMembers',
        display: false,
        highlighted: false,
        default: false,
        label: null,
        isEditing: false,
        isAdditional: false,
        isExternal: false,
        file: null,
      },
      {
        key: DealRoomSection.EMPLOYERS_LIABILITY,
        labelKey: 'dealRooms.sections.employersLiability',
        display: false,
        highlighted: false,
        default: false,
        label: null,
        isEditing: false,
        isAdditional: false,
        isExternal: false,
        file: null,
      },
      {
        key: DealRoomSection.SHARED_BUILDING_STRUCTURE,
        labelKey: 'dealRooms.sections.sharedBuildingStructure',
        display: false,
        highlighted: false,
        default: false,
        label: null,
        isEditing: false,
        isAdditional: false,
        isExternal: false,
        file: null,
      },
      {
        key: DealRoomSection.EARTHQUAKE,
        labelKey: 'dealRooms.sections.earthquake',
        display: false,
        highlighted: false,
        default: false,
        label: null,
        isEditing: false,
        isAdditional: false,
        isExternal: false,
        file: null,
      },
      {
        key: DealRoomSection.SHARED_BUILDING_CONTENTS,
        labelKey: 'dealRooms.sections.sharedBuildingContents',
        display: false,
        highlighted: false,
        default: false,
        label: null,
        isEditing: false,
        isAdditional: false,
        isExternal: false,
        file: null,
      },
    ],
  },
  {
    key: DealRoomSection.ELECTRIC_CHARGING_STATION,
    labelKey: 'dealRooms.sections.electricChargingStation',
    display: false,
    highlighted: false,
    default: false,
    label: null,
    isEditing: false,
    isAdditional: false,
    isExternal: false,
    file: null,
  },
  {
    key: DealRoomSection.LISTEN_TO_OUR_PODCASTS,
    labelKey: 'dealRooms.sections.listenToOurPodcasts',
    display: false,
    highlighted: false,
    default: false,
    label: null,
    isEditing: false,
    isAdditional: false,
    isExternal: false,
    file: null,
    subMenu: [
      {
        key: DealRoomSection.PODCAST_INSURANCE,
        labelKey: 'dealRooms.sections.podcastInsurance',
        display: false,
        highlighted: false,
        default: false,
        label: null,
        isEditing: false,
        isAdditional: false,
        isExternal: false,
        file: null,
      },
      {
        key: DealRoomSection.PODCAST_LEGAL,
        labelKey: 'dealRooms.sections.podcastLegal',
        display: false,
        highlighted: false,
        default: false,
        label: null,
        isEditing: false,
        isAdditional: false,
        isExternal: false,
        file: null,
      },
      {
        key: DealRoomSection.PODCAST_MANAGEMENT_APP,
        labelKey: 'dealRooms.sections.podcastManagementApp',
        display: false,
        highlighted: false,
        default: false,
        label: null,
        isEditing: false,
        isAdditional: false,
        isExternal: false,
        file: null,
      },
      {
        key: DealRoomSection.PODCAST_FIRE_SAFETY,
        labelKey: 'dealRooms.sections.podcastFireSafety',
        display: false,
        highlighted: false,
        default: false,
        label: null,
        isEditing: false,
        isAdditional: false,
        isExternal: false,
        file: null,
      },
      {
        key: DealRoomSection.PODCAST_MANAGEMENT_COMPANIES,
        labelKey: 'dealRooms.sections.podcastManagementCompanies',
        display: false,
        highlighted: false,
        default: false,
        label: null,
        isEditing: false,
        isAdditional: false,
        isExternal: false,
        file: null,
      },
      {
        key: DealRoomSection.PODCAST_MAINTENANCE,
        labelKey: 'dealRooms.sections.podcastMaintenance',
        display: false,
        highlighted: false,
        default: false,
        label: null,
        isEditing: false,
        isAdditional: false,
        isExternal: false,
        file: null,
      },
      {
        key: DealRoomSection.PODCAST_NEW_BUILDINGS_FORM_4,
        labelKey: 'dealRooms.sections.podcastNewBuildingsForm4',
        display: false,
        highlighted: false,
        default: false,
        label: null,
        isEditing: false,
        isAdditional: false,
        isExternal: false,
        file: null,
      },
    ],
  },
  {
    /** Children are attached at runtime from the deal room's comparisons, as DOCUMENTS does with its files. */
    key: DealRoomSection.COMPARISONS,
    labelKey: 'dealRooms.sections.comparisons',
    display: false,
    highlighted: false,
    default: false,
    label: null,
    isEditing: false,
    isAdditional: false,
    isExternal: false,
    file: null,
  },
  {
    key: DealRoomSection.DOCUMENTS,
    labelKey: 'dealRooms.sections.documents',
    display: false,
    highlighted: false,
    default: false,
    label: null,
    isEditing: false,
    isAdditional: false,
    isExternal: false,
    file: null,
  },
  {
    key: DealRoomSection.ATTACHMENTS,
    labelKey: 'dealRooms.sections.attachments',
    display: false,
    highlighted: false,
    default: false,
    label: null,
    isEditing: false,
    isAdditional: false,
    isExternal: false,
    file: null,
  },
];

export const dealRoomExtraSections: IDealRoomSectionContent[] = [
  {
    key: DealRoomSection.DECIDED_TO_PURCHASE_THE_INSURANCE,
    labelKey: 'dealRooms.sections.decidedToPurchaseTheInsurance',
    display: false,
    highlighted: false,
    default: false,
    label: null,
    isEditing: false,
    isAdditional: false,
    isExternal: false,
    file: null,
  },
];

export const dealRoomSections: IDealRoomSectionContent[] = dealRoomBaseSections.concat(dealRoomExtraSections);

export const dealRoomDisabledSections: IDealRoomSectionContent[] = [
  {
    key: DealRoomDisabledSection.LAMP_POLICY_AND_TERMS_AND_CONDITIONS,
    labelKey: `מנורה - פוליסה לדוגמא וחוברת תנאים`,
    display: false,
    highlighted: false,
    default: false,
    label: null,
    isEditing: false,
    isAdditional: true,
    isExternal: false,
    file: null,
  },
  {
    key: DealRoomDisabledSection.LAMP_SWIMMING_POOL_OF_THE_CONDOMINIUM,
    labelKey: `מנורה - חבות בגין בריכת שחייה של הבית המשותף`,
    display: false,
    highlighted: false,
    default: false,
    label: null,
    isEditing: false,
    isAdditional: true,
    isExternal: false,
    file: null,
  },
  {
    key: DealRoomDisabledSection.LAMP_SHARED_GYM,
    labelKey: `מנורה - חבות בגין חדר כושר משותף`,
    display: false,
    highlighted: false,
    default: false,
    label: null,
    isEditing: false,
    isAdditional: true,
    isExternal: false,
    file: null,
  },
  {
    key: DealRoomDisabledSection.LAMP_PLAYGROUND_OF_THE_CONDOMINIUM,
    labelKey: `מנורה - חבות בגין מתקני שעשועים של הבית המשותף`,
    display: false,
    highlighted: false,
    default: false,
    label: null,
    isEditing: false,
    isAdditional: true,
    isExternal: false,
    file: null,
  },
  {
    key: DealRoomDisabledSection.LAMP_PARKING_MULTIPLIER_VEHICLE_ELEVATOR_ROBOTIC_FACILITY,
    labelKey: `מנורה - חבות בגין מכפיל חניה, מעלית רכבים, מתקן רובוטי`,
    display: false,
    highlighted: false,
    default: false,
    label: null,
    isEditing: false,
    isAdditional: true,
    isExternal: false,
    file: null,
  },
  {
    key: DealRoomDisabledSection.LAMP_COMMERCIAL_SPACES,
    labelKey: `מנורה - חבות בגין שטחים מסחריים`,
    display: false,
    highlighted: false,
    default: false,
    label: null,
    isEditing: false,
    isAdditional: true,
    isExternal: false,
    file: null,
  },
  {
    key: DealRoomDisabledSection.LAMP_TENANT_ROOM_EVENT_ROOM_JAMBOREE,
    labelKey: `מנורה - חבות בגין חדר דיירים / חדר ארועים / ג'מבורי`,
    display: false,
    highlighted: false,
    default: false,
    label: null,
    isEditing: false,
    isAdditional: true,
    isExternal: false,
    file: null,
  },
  {
    key: DealRoomDisabledSection.LAMP_SAUNA_ROOM,
    labelKey: `מנורה - חבות בגין חדר סאונה`,
    display: false,
    highlighted: false,
    default: false,
    label: null,
    isEditing: false,
    isAdditional: true,
    isExternal: false,
    file: null,
  },
  {
    key: DealRoomDisabledSection.LAMP_JACUZZI,
    labelKey: `מנורה - חבות בגין ג'קוזי`,
    display: false,
    highlighted: false,
    default: false,
    label: null,
    isEditing: false,
    isAdditional: true,
    isExternal: false,
    file: null,
  },
  {
    key: DealRoomDisabledSection.LAMP_PRIVATE_OPEN_SPACE,
    labelKey: `מנורה - חבות בגין שטח פרטי פתוח (שפ"פ)`,
    display: false,
    highlighted: false,
    default: false,
    label: null,
    isEditing: false,
    isAdditional: true,
    isExternal: false,
    file: null,
  },
  {
    key: DealRoomDisabledSection.LAMP_MEMBERS_OF_A_CONDOMINIUM_REPRESENTATIVE_BODY,
    labelKey: `מנורה - חבות אישית של חברי נציגות בית משותף`,
    display: false,
    highlighted: false,
    default: false,
    label: null,
    isEditing: false,
    isAdditional: true,
    isExternal: false,
    file: null,
  },

  {
    key: DealRoomDisabledSection.RULE_SAMPLE_POLICY,
    labelKey: `כלל - פוליסה לדוגמא`,
    display: false,
    highlighted: false,
    default: false,
    label: null,
    isEditing: false,
    isAdditional: true,
    isExternal: false,
    file: null,
  },
  {
    key: DealRoomDisabledSection.RULE_SWIMMING_POOL_OF_THE_CONDOMINIUM,
    labelKey: `כלל - חבות בגין בריכת שחייה של הבית המשותף`,
    display: false,
    highlighted: false,
    default: false,
    label: null,
    isEditing: false,
    isAdditional: true,
    isExternal: false,
    file: null,
  },
  {
    key: DealRoomDisabledSection.RULE_PARKING_MULTIPLIER,
    labelKey: `כלל - חבות בגין מכפיל חניה`,
    display: false,
    highlighted: false,
    default: false,
    label: null,
    isEditing: false,
    isAdditional: true,
    isExternal: false,
    file: null,
  },
  {
    key: DealRoomDisabledSection.RULE_COMMERCIAL_SPACES,
    labelKey: `כלל - חבות בגין שטחים מסחריים`,
    display: false,
    highlighted: false,
    default: false,
    label: null,
    isEditing: false,
    isAdditional: true,
    isExternal: false,
    file: null,
  },
  {
    key: DealRoomDisabledSection.RULE_PLAYGROUND_OF_THE_CONDOMINIUM,
    labelKey: `כלל - חבות בגין מתקני שעשועים של הבית המשותף`,
    display: false,
    highlighted: false,
    default: false,
    label: null,
    isEditing: false,
    isAdditional: true,
    isExternal: false,
    file: null,
  },
  {
    key: DealRoomDisabledSection.RULE_SHARED_GYM,
    labelKey: `כלל - חבות בגין חדר כושר משותף`,
    display: false,
    highlighted: false,
    default: false,
    label: null,
    isEditing: false,
    isAdditional: true,
    isExternal: false,
    file: null,
  },
  {
    key: DealRoomDisabledSection.RULE_TENANT_ROOM_EVENT_ROOM,
    labelKey: `כלל - חבות בגין חדר דיירים / חדר ארועים`,
    display: false,
    highlighted: false,
    default: false,
    label: null,
    isEditing: false,
    isAdditional: true,
    isExternal: false,
    file: null,
  },

  {
    key: DealRoomDisabledSection.PHOENIX_SAMPLE_POLICY,
    labelKey: `פניקס - פוליסה לדוגמא`,
    display: false,
    highlighted: false,
    default: false,
    label: null,
    isEditing: false,
    isAdditional: true,
    isExternal: false,
    file: null,
  },
  {
    key: DealRoomDisabledSection.PHOENIX_CONDOMINIUM_SWIMMING_POOL,
    labelKey: `פניקס - חבות בגין בריכת שחייה של הבית המשותף`,
    display: false,
    highlighted: false,
    default: false,
    label: null,
    isEditing: false,
    isAdditional: true,
    isExternal: false,
    file: null,
  },
  {
    key: DealRoomDisabledSection.PHOENIX_SHARED_GYM,
    labelKey: `פניקס - חבות בגין חדר כושר משותף`,
    display: false,
    highlighted: false,
    default: false,
    label: null,
    isEditing: false,
    isAdditional: true,
    isExternal: false,
    file: null,
  },
  {
    key: DealRoomDisabledSection.PHOENIX_CONDOMINIUM_PLAYGROUND_EQUIPMENT,
    labelKey: `פניקס - חבות בגין מתקני שעשועים של הבית המשותף`,
    display: false,
    highlighted: false,
    default: false,
    label: null,
    isEditing: false,
    isAdditional: true,
    isExternal: false,
    file: null,
  },
  {
    key: DealRoomDisabledSection.PHOENIX_PARKING_MULTIPLIER_VEHICLE_ELEVATOR_ROBOTIC_FACILITY,
    labelKey: `פניקס - חבות בגין מכפיל חניה, מעלית רכבים, מתקן רובוטי`,
    display: false,
    highlighted: false,
    default: false,
    label: null,
    isEditing: false,
    isAdditional: true,
    isExternal: false,
    file: null,
  },
  {
    key: DealRoomDisabledSection.PHOENIX_COMMERCIAL_SPACES,
    labelKey: `פניקס - חבות בגין שטחים מסחריים`,
    display: false,
    highlighted: false,
    default: false,
    label: null,
    isEditing: false,
    isAdditional: true,
    isExternal: false,
    file: null,
  },
  {
    key: DealRoomDisabledSection.PHOENIX_TENANT_ROOM_EVENT_ROOM_GYM,
    labelKey: `פניקס - חבות בגין חדר דיירים / חדר ארועים / גי'מבורי`,
    display: false,
    highlighted: false,
    default: false,
    label: null,
    isEditing: false,
    isAdditional: true,
    isExternal: false,
    file: null,
  },
  {
    key: DealRoomDisabledSection.PHOENIX_SAUNA_ROOM,
    labelKey: `פניקס - חבות בגין חדר סאונה`,
    display: false,
    highlighted: false,
    default: false,
    label: null,
    isEditing: false,
    isAdditional: true,
    isExternal: false,
    file: null,
  },
  {
    key: DealRoomDisabledSection.PHOENIX_JACUZZI,
    labelKey: `פניקס - חבות בגין ג'קוזי`,
    display: false,
    highlighted: false,
    default: false,
    label: null,
    isEditing: false,
    isAdditional: true,
    isExternal: false,
    file: null,
  },
  {
    key: DealRoomDisabledSection.PHOENIX_MEMBERS_OF_THE_CONDOMINIUM_REPRESENTATIVE_BODY,
    labelKey: `פניקס - חבות אישית של חברי נציגות בית משותף`,
    display: false,
    highlighted: false,
    default: false,
    label: null,
    isEditing: false,
    isAdditional: true,
    isExternal: false,
    file: null,
  },
  {
    key: DealRoomDisabledSection.TRAINING_SAMPLE_POLICY,
    labelKey: `הכשרה - פוליסה לדוגמא`,
    display: false,
    highlighted: false,
    default: false,
    label: null,
    isEditing: false,
    isAdditional: true,
    isExternal: false,
    file: null,
  },
  {
    key: DealRoomDisabledSection.AYALON_SAMPLE_POLICY,
    labelKey: `איילון - פוליסה לדוגמא`,
    display: false,
    highlighted: false,
    default: false,
    label: null,
    isEditing: false,
    isAdditional: true,
    isExternal: false,
    file: null,
  },
  {
    key: DealRoomDisabledSection.AYALON_SAMPLE_LIST_PAGE,
    labelKey: `איילון - דף רשימה לדוגמא`,
    display: false,
    highlighted: false,
    default: false,
    label: null,
    isEditing: false,
    isAdditional: true,
    isExternal: false,
    file: null,
  },
];

const files = [
  `מנורה - פוליסה לדוגמא וחוברת תנאים.pdf`,
  `מנורה - הרחבים צד ג.pdf`,
  `כלל ביטוח - פוליסה לדוגמא.pdf`,
  `הפניקס - פוליסה לדוגמא.pdf`,
  `הכשרה - פוליסה לדוגמא.pdf`,
  `איילון כולל מבנה - פוליסה וחוברת תנאים.pdf`,
  `איילון - דף רשימה לדוגמא.pdf`,
];

export const dealRoomDisabledSectionFiles = [
  {
    section: DealRoomDisabledSection.LAMP_POLICY_AND_TERMS_AND_CONDITIONS,
    file: files[0],
    pageStart: 0,
    pageEnd: 0,
  },
  {
    section: DealRoomDisabledSection.LAMP_SWIMMING_POOL_OF_THE_CONDOMINIUM,
    file: files[1],
    pageStart: 41,
    pageEnd: 41,
  },
  {
    section: DealRoomDisabledSection.LAMP_SHARED_GYM,
    file: files[1],
    pageStart: 41,
    pageEnd: 41,
  },
  {
    section: DealRoomDisabledSection.LAMP_PLAYGROUND_OF_THE_CONDOMINIUM,
    file: files[1],
    pageStart: 42,
    pageEnd: 42,
  },
  {
    section: DealRoomDisabledSection.LAMP_PARKING_MULTIPLIER_VEHICLE_ELEVATOR_ROBOTIC_FACILITY,
    file: files[1],
    pageStart: 42,
    pageEnd: 42,
  },
  {
    section: DealRoomDisabledSection.LAMP_COMMERCIAL_SPACES,
    file: files[1],
    pageStart: 43,
    pageEnd: 43,
  },
  {
    section: DealRoomDisabledSection.LAMP_TENANT_ROOM_EVENT_ROOM_JAMBOREE,
    file: files[1],
    pageStart: 43,
    pageEnd: 43,
  },
  {
    section: DealRoomDisabledSection.LAMP_SAUNA_ROOM,
    file: files[1],
    pageStart: 44,
    pageEnd: 44,
  },
  {
    section: DealRoomDisabledSection.LAMP_JACUZZI,
    file: files[1],
    pageStart: 44,
    pageEnd: 44,
  },
  {
    section: DealRoomDisabledSection.LAMP_PRIVATE_OPEN_SPACE,
    file: files[1],
    pageStart: 44,
    pageEnd: 44,
  },
  {
    section: DealRoomDisabledSection.LAMP_MEMBERS_OF_A_CONDOMINIUM_REPRESENTATIVE_BODY,
    file: files[1],
    pageStart: 44,
    pageEnd: 44,
  },
  {
    section: DealRoomDisabledSection.RULE_SAMPLE_POLICY,
    file: files[2],
    pageStart: 0,
    pageEnd: 0,
  },
  {
    section: DealRoomDisabledSection.RULE_SWIMMING_POOL_OF_THE_CONDOMINIUM,
    file: files[2],
    pageStart: 26,
    pageEnd: 26,
  },
  {
    section: DealRoomDisabledSection.RULE_PARKING_MULTIPLIER,
    file: files[2],
    pageStart: 26,
    pageEnd: 26,
  },
  {
    section: DealRoomDisabledSection.RULE_COMMERCIAL_SPACES,
    file: files[2],
    pageStart: 27,
    pageEnd: 27,
  },
  {
    section: DealRoomDisabledSection.RULE_PLAYGROUND_OF_THE_CONDOMINIUM,
    file: files[2],
    pageStart: 27,
    pageEnd: 27,
  },
  {
    section: DealRoomDisabledSection.RULE_SHARED_GYM,
    file: files[2],
    pageStart: 27,
    pageEnd: 27,
  },
  {
    section: DealRoomDisabledSection.RULE_TENANT_ROOM_EVENT_ROOM,
    file: files[2],
    pageStart: 28,
    pageEnd: 28,
  },
  {
    section: DealRoomDisabledSection.PHOENIX_SAMPLE_POLICY,
    file: files[3],
    pageStart: 0,
    pageEnd: 0,
  },
  {
    section: DealRoomDisabledSection.PHOENIX_CONDOMINIUM_SWIMMING_POOL,
    file: files[3],
    pageStart: 28,
    pageEnd: 28,
  },
  {
    section: DealRoomDisabledSection.PHOENIX_SHARED_GYM,
    file: files[3],
    pageStart: 29,
    pageEnd: 29,
  },
  {
    section: DealRoomDisabledSection.PHOENIX_CONDOMINIUM_PLAYGROUND_EQUIPMENT,
    file: files[3],
    pageStart: 29,
    pageEnd: 29,
  },
  {
    section: DealRoomDisabledSection.PHOENIX_PARKING_MULTIPLIER_VEHICLE_ELEVATOR_ROBOTIC_FACILITY,
    file: files[3],
    pageStart: 30,
    pageEnd: 30,
  },
  {
    section: DealRoomDisabledSection.PHOENIX_COMMERCIAL_SPACES,
    file: files[3],
    pageStart: 30,
    pageEnd: 30,
  },
  {
    section: DealRoomDisabledSection.PHOENIX_TENANT_ROOM_EVENT_ROOM_GYM,
    file: files[3],
    pageStart: 31,
    pageEnd: 31,
  },
  {
    section: DealRoomDisabledSection.PHOENIX_SAUNA_ROOM,
    file: files[3],
    pageStart: 31,
    pageEnd: 31,
  },
  {
    section: DealRoomDisabledSection.PHOENIX_JACUZZI,
    file: files[3],
    pageStart: 32,
    pageEnd: 32,
  },
  {
    section: DealRoomDisabledSection.PHOENIX_MEMBERS_OF_THE_CONDOMINIUM_REPRESENTATIVE_BODY,
    file: files[3],
    pageStart: 32,
    pageEnd: 32,
  },
  {
    section: DealRoomDisabledSection.TRAINING_SAMPLE_POLICY,
    file: files[4],
    pageStart: 0,
    pageEnd: 0,
  },
  {
    section: DealRoomDisabledSection.AYALON_SAMPLE_POLICY,
    file: files[5],
    pageStart: 0,
    pageEnd: 0,
  },
  {
    section: DealRoomDisabledSection.AYALON_SAMPLE_LIST_PAGE,
    file: files[6],
    pageStart: 0,
    pageEnd: 0,
  },
];
